import { render, staticRenderFns } from "./plan-objetivos-editar.vue?vue&type=template&id=3d95e9bb&scoped=true&"
import script from "./plan-objetivos-editar.vue?vue&type=script&lang=js&"
export * from "./plan-objetivos-editar.vue?vue&type=script&lang=js&"
import style0 from "./plan-objetivos-editar.vue?vue&type=style&index=0&id=3d95e9bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d95e9bb",
  null
  
)

export default component.exports